module.exports = __webpack_public_path__ + "img/va.d1b4d52e.png";